import styled from "styled-components";
import { Paragraph2 } from "../Text/Paragraphs";

export const AddButtonStyled = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  gap: 10px;

  ${Paragraph2} {
    font-weight: 600;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default !important;
  }
`;
